export const COLOR_GREEN = '#1dde77';
export const COLOR_YELLOW = '#f2f56e';
export const COLOR_RED = '#d71e00';
export const COLOR_BLUE = '#0087C1';
export const COLOR_DARK_GREY = '#2F2F2F';